import React, { Component } from 'react';
import axios from 'axios';
import {Link} from 'react-router-dom'

class Movies extends Component {
    constructor(){
        super();
        this.state = {
            hover: '',
            parr: [1],
            currPage: 1,
            movies:[],
            favourites:[]
        }
    }

    async componentDidMount(){
        const res =await axios.get(`https://api.themoviedb.org/3/movie/popular?api_key=c5f0a2aa6d23237292358ddb58bfbfed&language=en-US&page=${this.state.currPage}`);
        let data = res.data;
        this.setState({
            movies : [...data.results]
        })
    }

    changeMovie = async ()=>{
        const res =await axios.get(`https://api.themoviedb.org/3/movie/popular?api_key=c5f0a2aa6d23237292358ddb58bfbfed&language=en-US&page=${this.state.currPage}`);
        let data = res.data;
        this.setState({
            movies : [...data.results]
        })
    }

    handleNextPage = () => {
        let temparr = []
        for(let i =1; i<=this.state.parr.length+1;i++){
            temparr.push(i);
        }

        this.setState({
            parr : [...temparr],
            currPage : this.state.currPage + 1
        },this.changeMovie);
        
    }

    handlePrevPage = () =>{
        if(this.state.currPage>1){
            this.setState({
                currPage : this.state.currPage - 1
            },this.changeMovie);
        }
    }

    handleClickPage = (value) =>{
        if(value != this.state.currPage){
            this.setState({
                currPage : value
            },this.changeMovie)
        }
    }

    handleFavourites = (movie) => {
        let oldData = JSON.parse(localStorage.getItem('movies') || "[]");
        if(this.state.favourites.includes(movie.id)){
            oldData = oldData.filter((m)=>m.id != movie.id);
        }else{
            oldData.push(movie)
        }
        localStorage.setItem('movies',JSON.stringify(oldData));
        this.handleFavouritesState();
    }

    handleFavouritesState=()=>{
        let oldData = JSON.parse(localStorage.getItem('movies') || "[]");
        let temp = oldData.map((movie)=>movie.id);
        this.setState({
            favourites: [...temp],
        })
    }

  render() {
    console.log("render");
    return(
        <>
        {
            this.state.movies.length == 0 ?
            <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
            </div>  :
            <div>
                <h3 className='text-center'><strong>Trending</strong></h3>
                <div className='movies-list'>
                    {
                        this.state.movies.map((movieObj)=>(
                            <div className="card movies-card" onMouseEnter={()=>this.setState({hover:movieObj.id})} onMouseLeave={()=>this.setState({hover:''})} >
                                <img src={`https://image.tmdb.org/t/p/original${movieObj.backdrop_path}`} className ="card-img-top movies-img" alt={movieObj.title} />
                                <h3 className="card-title movies-title" >{movieObj.original_title}</h3 >
                                <div className='button-wrapper' style={{display:'flex',width: '100%',justifyContent:'center'}}>
                                    {
                                        this.state.hover == movieObj.id &&
                                        <a className='btn btn-primary movies-button' onClick={()=>this.handleFavourites(movieObj)}>{this.state.favourites.includes(movieObj.id) ? "Remove to Favourite": "Add to Favourite"}</a>
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div style={{display:"flex",justifyContent:'center'}}>
                    <nav aria-label="Page navigation example">
                    <ul className="pagination">
                        <li className="page-item"><a className="page-link" onClick={this.handlePrevPage}>Previous</a></li>
                        {
                            this.state.parr.map((value)=>(
                                <li className="page-item"><a className="page-link" onClick={() => this.handleClickPage(value)}>{value}</a></li>
                            ))
                        }
                        <li className="page-item"><a className="page-link" onClick={this.handleNextPage}>Next</a></li>
                    </ul>
                    </nav>
                </div>
            </div>
        }
        </>
    )
  }
}

export default Movies